import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectJumioModal,
  selectUrlverify,
  setUrlverify,
  setShowJumio,
} from "../../features/modals/modalsSlice";
import ModalPago from "../modals/ModalBoth";
import { ContainerModal, ModalTitle, ButtonClose } from "./JumioElements";
import {
  selectCurrency,
  selectId,
  selectToken,
  setNewToken,
  setUserBets,
} from "../../features/user/userSlice";
import axios from "axios";
import { API_URL } from "../../const/api";
import CloseIcon from '@mui/icons-material/Close';

const JumioVerification = () => {
  const id = useSelector(selectId);
  const token = useSelector(selectToken);
  const moneda = useSelector(selectCurrency);

  const dispatch = useDispatch();
  const open = useSelector(selectJumioModal);
  const Urljumio = useSelector(selectUrlverify);

  const refreshData = async () => {
    let body = { id: id, token: token };
    const res = await axios.post(API_URL + "user", body);
    const responsePerfil = await axios.post(API_URL + "datosApuestaUser", {
      token: res.data.token,
      id_uo: id,
      moneda,
    });

    dispatch(setNewToken(res.data.token));
    dispatch(setUserBets(responsePerfil.data.response));
  };

  const handleClose = () => {
    //refreshData();
    window.location.href = "/";
    dispatch(setShowJumio(false));
    dispatch(setUrlverify(""));
  };

  return (
    <ModalPago
      open={open}
      handleClose={handleClose}
      maxWidth="xl"
      children={
        <ContainerModal>
          <ModalTitle>
            <h2>Verificar cuenta</h2>
            <ButtonClose onClick={handleClose}>
              <CloseIcon />
            </ButtonClose>
          </ModalTitle>
          <iframe
            title="Jumio"
            src={Urljumio}
            width="100%"
            height="650px"
            border="none"
            padding="5px"
            allow="camera; autoplay; fullscreen; clipboard-read; clipboard-write; accelerometer; gyroscope; magnetometer;"
          ></iframe>
        </ContainerModal>
      }
    />
  );
};

export default JumioVerification;
